export const getURLWithLoggingContext = (
  url: string | null,
  suggestionResponseId: string,
  suggestionName: string,
  suggestionType?: string,
  suggestionActivationType?: 'suggestion' | 'redirect',
) => {
  if (!url || (suggestionType !== 'PLP' && suggestionType !== 'SRP')) {
    return url;
  }

  const loggingContext = JSON.stringify({
    suggestionResponseId,
    suggestionName,
    suggestionType,
    suggestionActivationType,
  });

  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}loggingContext=${encodeURIComponent(loggingContext)}`;
};
